import { config } from './config/generated-config'

export const getJamsBackendApi = () => {
  return config.VITE_JAMS_BACKEND_URL
}

export const getJamsFrontendApi = () => {
  return config.VITE_JAMS_FRONTEND_URL
}

export const getQrServiceEndpoint = () => {
  return config.VITE_JAMS_QR_API
}

export const getInventoryApi = () => {
  return config.VITE_INVENTORY_API
}

export const getUploadServiceApi = () => {
  return config.VITE_UPLOAD_SERVICE_API_BASE_URL
}

export const getComponentsBucketName = () => {
  return (config as any).VITE_COMPONENTS_BUCKET_NAME as string
}

export function getAccountId(): string {
  // Check URL parameters first
  const urlParams = new URLSearchParams(window.location.search)
  const accountIdFromUrl = urlParams.get('account_id')

  if (accountIdFromUrl && accountIdFromUrl !== '') {
    return accountIdFromUrl
  }

  // Check DOM attributes
  const wpElement = document.getElementById('scan2sell')
  const accountIdFromElement = wpElement?.getAttribute('data-account-id')

  if (accountIdFromElement && accountIdFromElement !== '') {
    return accountIdFromElement
  }

  return ''
}

export const storeDataInSessionStorage = (key: string, data: string) => {
  sessionStorage.setItem(key, JSON.stringify(data))
}

export const getDataFromSessionStorage = (key: string): string => {
  const data = sessionStorage.getItem(key)
  return data ? JSON.parse(data) : null
}

export const formatAccountName = (name: string): string => {
  return name.replace(/_/g, ' ')
}

export const formatPlacementIdToFriendlyName = (id: string) => {
  return id.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
}

export const formatPrice = (price: string | number): string => {
  if (!price) return ''

  const numPrice =
    typeof price === 'string'
      ? parseFloat(price.replace(/[^\d.-]+/g, ''))
      : price

  if (isNaN(numPrice)) return ''

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numPrice)
}
